module.exports = __webpack_public_path__ + "img/ra-1000.png";